/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import byIdSaga from './byId';
import createSaga from './create';
import createAdminSaga from './createAdmin';
import updateSaga from './update';
import resendLinkSaga from './resendLink';
import deleteSaga from './delete';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { User } from '../auth';
import { PaginatedResponse } from '../types';

export const moduleName = 'user';

export interface State {
  list: BaseState<PaginatedResponse<User>>,
  byId: BaseState<User>,
  create: BaseState<{ id: string }>,
  createAdmin: BaseState<{ id: string }>,
  update: BaseState<{ success: boolean }>,
  delete: BaseState<{ id: string }>
  resendLink: BaseState<{ success: boolean }>
}

const models = ['list', 'byId', 'create', 'createAdmin', 'update', 'delete', 'resendLink'];

export const defaultState: State = createCRUDStates<State>(models);

export const user = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = user;

export function useUser(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* byIdSaga();
  yield* createSaga();
  yield* createAdminSaga();
  yield* updateSaga();
  yield* resendLinkSaga();
  yield* deleteSaga();
}
